import { createSlice } from "@reduxjs/toolkit";

const initialState = { screenGlobalSearchData: "", contentGlobalSearchData: "" };

const searchParamsSlice = createSlice({
    name: "searchParams",
    initialState,
    reducers: {
        setScreenGlobalSearch: (state, action) => {
            const data = action.payload;
            return { ...state, screenGlobalSearchData: data };
        },
        setContentGlobalSearch: (state, action) => {
            const data = action.payload;
            return { ...state, contentGlobalSearchData: data };
        },
    },
});

export const { setScreenGlobalSearch, setContentGlobalSearch } = searchParamsSlice.actions;

export default searchParamsSlice.reducer;
